import { Employee } from "../employee-list";
import React from "react";
import imgDrJanHeilmann from ".././media/dr-jan-heilmann.jpg";
import i18n from "../../../generic/i18n";

export const drJanHeilmann: Employee = {
  slug: "dr-jan-heilmann",
  displayName: "Dr. Jan Heilmann",
  title: "lawyer-male-ir",
  isExternal: true,
  isCounsel: false,
  subTitle: "",
  awards: [],
  img: imgDrJanHeilmann,
  languages: ["deu", "eng"],
};
